export const convertToStringOrNull = (condition: boolean, value: string) => {
    return condition ? value : null;
};
